import Td from "./Td";
import { Draggable, Droppable } from "react-beautiful-dnd";
import { motion, AnimatePresence } from "framer-motion";

const Tbody = ({
  tableData = [],
  isOrdering = true,
  tableActionDropdownContainer,
  isLoder,
}) => {
  return (
    <Droppable droppableId="table-list" isDropDisabled={isOrdering}>
      {(provided) => (
        <tbody
          className="text-sidebar text-sm font-medium"
          {...provided.droppableProps}
          ref={provided.innerRef}
        >
          <AnimatePresence>
            {tableData.map((item, index) => (
              <Draggable
                key={item?._id}
                draggableId={item?._id?.toString()}
                index={index}
                isDragDisabled={isOrdering}
              >
                {(provided) => (
                  <motion.tr
                    layout
                    key={item?._id}
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                    initial={{ opacity: 0, scale: 0.95 }}
                    animate={{ opacity: 1, scale: 1 }}
                    exit={{
                      opacity: 0,
                      scale: 0.8,
                      transition: { duration: 0.3 },
                    }}
                    className="border-b border-border-color last:border-b-0 hover:bg-mauve/10"
                  >
                    {item.rowData.map((itemData, i) => (
                      <Td
                        key={itemData?._id + i}
                        data={itemData}
                        align={itemData?.align}
                        actionData={itemData.actionData}
                        functions={itemData?.functions}
                        onClick={itemData?.onClick}
                        checkboxChecked={itemData.checked || false}
                        tableActionDropdownContainer={
                          tableActionDropdownContainer
                        }
                        onCheckboxChange={() =>
                          itemData.onCheckboxChange
                            ? itemData.onCheckboxChange(
                                itemData.itemDetails || {},
                              )
                            : () => {}
                        }
                      />
                    ))}
                  </motion.tr>
                )}
              </Draggable>
            ))}
          </AnimatePresence>
          {provided.placeholder}
        </tbody>
      )}
    </Droppable>
  );
};

export default Tbody;
